import { Flex } from "@chakra-ui/layout";
import { getTenantTipoName } from "core/features/tenants/helpers";
import { TenantDetalhe } from "core/features/tenants/typings/tenant";
import { BsBank } from "react-icons/bs";
import PageHeader from "ui/components/Page/PageHeader";

function TenantHeader({ tenant }: { tenant?: TenantDetalhe }) {
  return (
    <PageHeader
      title={
        tenant?.id ? (
          <Flex gap="8px" fontWeight="bold">
            <BsBank />
            {tenant.pessoa.nomeFantasia || tenant.pessoa.nome}
          </Flex>
        ) : (
          "Criar Cliente"
        )
      }
      extraButtonTitle={getTenantTipoName(tenant?.tipoTenantId!)!}
    />
  );
}

export default TenantHeader;
